import styled, { keyframes } from "styled-components";

const logoPulse = keyframes`
	0%,
	100% {
		opacity: 0.75;
		transform: scale(0.98);
		filter:
			drop-shadow(0 8px 24px rgba(0, 0, 0, 0.35))
			drop-shadow(0 0 8px rgba(212, 158, 84, 0.1));
	}

	50% {
		opacity: 1;
		transform: scale(1);
		filter:
			drop-shadow(0 10px 28px rgba(0, 0, 0, 0.4))
			drop-shadow(0 0 18px rgba(212, 158, 84, 0.25));
	}
`;

const textFade = keyframes`
	0%,
	100% {
		opacity: 0.6;
	}

	50% {
		opacity: 1;
	}
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	width: 100%;
	min-height: 100vh;

	background: #000;
`;

export const LogoPicture = styled.picture`
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const Logo = styled.img`
	display: block;

	width: min(382px, 72vw);
	height: auto;

	animation: ${logoPulse} 1.6s ease-in-out infinite;

	filter:
		drop-shadow(0 8px 24px rgba(0, 0, 0, 0.35))
		drop-shadow(0 0 10px rgba(212, 158, 84, 0.15));
`;

export const LoadingText = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;

	margin-top: 18px;

	font-family: Montserrat, sans-serif;
	font-size: 12px;
	font-weight: 500;

	letter-spacing: 0.18em;
	text-transform: uppercase;

	color: rgba(255, 255, 255, 0.75);

	animation: ${textFade} 1.6s ease-in-out infinite;
`;
